// The Earnings panel's strings. They live here rather than in copy.ts, which
// is past the file budget (EPIC-022 Locked architecture).
export const earningsCopy = {
  heading: "Your earnings",
  live: "Live contests",
  liveRow: (amount: string, backers: number) => `${amount} earned from ${backers} ${backers === 1 ? "backer" : "backers"}`,
  liveNote: "Estimates from the picks so far. Paid when each contest settles, win or lose.",
  byContest: "By contest",
  backingShare: "Backing share",
  winnerCut: "Winner's cut",
  total: "Total",
  lifetime: "Lifetime",
  pastContest: "A past contest",
  empty:
    "Nothing yet. Every producer earns a share of the fan picks on them, win or lose, and the winner takes a cut too.",
  error: "Your earnings didn't load.",
  reload: "Reload earnings",
};
